module.exports = __webpack_public_path__ + "img/kvinta_ua.11a7d724.svg";